import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]




export default /*@__PURE__*/_defineComponent({
  __name: 'ExerciseIcon',
  props: {
  color: {
    type: String,
    default: '#C671C2'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M10.6948 19.0738L9.73229 18.1113L12.9865 14.8572L4.23229 6.10299L0.978125 9.35716L0.015625 8.39466L1.29896 7.06549L0.015625 5.78216L1.96354 3.83424L1.00104 2.87174L1.96354 1.90924L2.94896 2.84883L4.87396 0.923828L6.15729 2.20716L7.48646 0.923828L8.44896 1.88633L5.19479 5.14049L13.949 13.8947L17.2031 10.6405L18.1656 11.603L16.8823 12.9322L18.1656 14.2155L16.1948 16.1863L17.1573 17.1488L16.1948 18.1113L15.2323 17.1488L13.3073 19.0738L12.024 17.7905L10.6948 19.0738Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})